import './page/search-stats-list';
import './page/search-stats-detail';

Shopware.Module.register('topdata-es-search-stats', {
    type: 'plugin',
    name: 'SearchStats',
    title: 'TopdataEnhancedSearchSW6.topdata-es-search-stats.title',
    description: 'TopdataEnhancedSearchSW6.topdata-es-search-stats.description',
    color: '#189eff',
    icon: 'default-shopping-search',

    routes: {
        list: {
            component: 'topdata-es-search-stats-list',
            path: 'list',
            meta: {
                privilege: 'system.zero_search.viewer',
            },
        },
        detail: {
            component: 'topdata-es-search-stats-detail',
            path: 'detail/:id',
            meta: {
                parentPath: 'topdata.es.search.stats.list',
                privilege: 'system.zero_search.viewer',
            },
        },
    },

    navigation: [{
        id: 'topdata-es-search-stats',
        parent: 'topdata-es',
        label: 'TopdataEnhancedSearchSW6.topdata-es-search-stats.title',
        path: 'topdata.es.search.stats.list',
        icon: 'default-shopping-search',
        privilege: 'system.zero_search.viewer',
    }],
});
